const YTVideo = {
  init() {
    if (!$(".yt-video").length) {
      return;
    }

    let isHomepage = false;

    if ($(".template-home").length) {
      isHomepage = true;
    }

    if (isHomepage && window.innerWidth < 900) {
      return false;
    }

    // Create script
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // Add global function
    window.videoYTRender = function () {
      $(".yt-video").each(function () {
        const wraperEl = $(this);
        const videoEl = wraperEl.find(".yt-video__video");

        const videoId = videoEl.data("id");

        let playerVars = {
          autoplay: isHomepage ? 0 : 1,
          cc_load_policy: 0,
          controls: isHomepage ? 0 : 1,
          fs: isHomepage ? 0 : 1,
          iv_load_policy: 3,
          loop: isHomepage ? 1 : 0,
          modestbranding: 1,
          origin: location.origin,
          playsinline: 1,
          mute: isHomepage ? 1 : 0,
          rel: 0,
          start: 0,
        };

        if (isHomepage) {
          playerVars = { ...playerVars, playlist: videoId };
        }

        new YT.Player(videoEl[0], {
          videoId: videoId, // YouTube Video ID
          width: 560,
          height: 316,
          playerVars: playerVars,
          events: {
            onReady: function (e) {
              const player = e.target;
              player.mute();

              wraperEl.find(".yt-video__poster").on("click", function () {
                player.seekTo(0).playVideo();
                wraperEl.addClass("playing");
              });

              if (isHomepage) {
                setTimeout(() => {
                  player.seekTo(0).playVideo();
                  setTimeout(() => {
                    wraperEl.addClass("playing");
                  }, 1200);
                }, 200);
              }
            },
          },
        });
      });
    };
  },
};

export default YTVideo;
